<template>
    <v-dialog v-model="openDialog" scrollable max-width="600px">
      <v-card >
        <v-toolbar flat class="mb-0">
          <!-- <a @click="closeDialog">
            <v-list-item>
              <v-img
                src="@/assets/icon/bacck.png"
                lazy-src="@/assets/icon/bacck.png"
                max-width="20"
              ></v-img>
              <v-list-item-content>
                <v-list-item-title>
                  <v-btn text color="primary">Back</v-btn>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </a> -->
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDialog">Close</v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="q-report">
            <v-row>
              <v-col
                cols="12"
                class="mb-0"
                v-for="(reportAnswer, index) in studentList"
                :key="reportAnswer._id"
              >
                <v-row class="px-3">
                  <v-list-item three-line>
                    <v-list-item-icon>
                      <p class="headline my-3 ml-3 mr-2z">
                        {{ limit * (currentPage - 1) + (index + 1) }}
                      </p>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="title mb-0 mr-2">{{
                        reportAnswer.created_by
                      }} </v-list-item-title>
                      <v-list-item-subtitle>{{
                        reportAnswer.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-chip
                      class="ma-2"
                      color="#FF8F03"
                      label
                      text-color="white"
                      >{{ reportAnswer.timeUse + ' ' }} sec</v-chip
                    >
                  </v-list-item>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <div >
          <v-divider></v-divider>
          <v-card-actions>
            <v-row justify="center" class="ma-0">
              <v-pagination
                v-model="currentPage"
                :length="totalPage"
                @input="changePage"
              ></v-pagination>
            </v-row>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
</template>
<script>
import {
  getAnswerStudentList
} from '@/service/course/livev2';
export default {
  props: {
    isDialogOpen: {
      type: Boolean
    },
    closeDialog: {
      type: Function
    },
    choiceId: {

    },
    quizId: {

    },
    liveId: {

    }
  },
  data() {
    return {
    limit: 5,
    openDialog: false,
    currentPage: 1,
    totalPage: 1,
    studentList: [],
  }},
  watch: {
    isDialogOpen: async function(newValue) {
      if (newValue) {
        this.openDialog = true
        this.initialize();
      }
      else {
        this.openDialog = false
      }
    }
  },
  methods: {
    initialize() {
      this.limit = 5
      this.currentPage = 1
      this.totalPage = 1
      this.studentList = []
      this.getList()
    },
    async getList(){
      let params = {
        liveId: this.liveId,
        quizId: this.quizId,
        choiceId: this.choiceId
      }
      let offset = `${(this.currentPage - 1) * this.limit},${this.limit}`
      let result = await getAnswerStudentList(params, {offset})
      let tmpList = []
      result.studentList.forEach((state) => {
        tmpList.push({
          livestreamID: this.liveId,
          id: state._id,
          timeUse: (state.timeUse / 1000).toFixed(2),
          created_by: state.student.displayName,
          email: state.student.email,
          studentId: state.student._id,
        });
      });
      this.studentList = tmpList
      this.totalPage = result.totalPage
      // totalPage = result.
    },
    async changePage(page){
      this.currentPage = page
      await this.getList()
    }
  }
};
</script>